import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Loader from "@icarius-common/loader";
import { isKeyPresent, getValueFromKey } from "@icarius-utils/localStorage";
import { createTheme } from "@icarius-utils/theme";
import { getHasToChangePin, getIsAuthorized, getTheme } from "@icarius-pages/login/selectors";
import { Snackbar } from "@icarius-common/snackbar";
import { Dialog } from "@icarius-common/dialog";
import { LOCAL_STORAGE_LANGUAGE_KEY, setLanguage } from "@icarius-localization/strings";
import useSkipLoginWithToken from "./useSkipLoginWithToken";
import Wrapper from "./wrapper";
import OuterRoutes from "./outerRoutes";

const App = () => {
  // limpiar el state del history para evitar bugs en pantallas con redirect
  window.history.replaceState({}, document.title)

  // setear titulo cada vez
  document.title = 'ICARIUS';

  useEffect(() => {
    // setear el del localStorage (o dark) como inicial hasta que el Login obtenga el del cliente
    document.documentElement.setAttribute('data-theme', isKeyPresent("icarius-theme") ? getValueFromKey("icarius-theme") : 'dark');

    // setear lenguaje inicial
    setLanguage(getValueFromKey(LOCAL_STORAGE_LANGUAGE_KEY));

    const handleLanguageChange = () => {
      setLanguageKey(prev => prev + 1);
    };
    window.addEventListener('languageChanged', handleLanguageChange);

    const handleGlobalKeyDown = (e) => {
      if (e.key === 'Escape') {
        const closeIcons = Array.from(document.querySelectorAll('.dialog-close-icon')).filter(
          icon => icon.offsetParent !== null
        );
        if (closeIcons.length > 0) {
          e.stopPropagation();
          const topMostCloseIcon = closeIcons[closeIcons.length - 1];
          if (typeof topMostCloseIcon.click === 'function') {
            topMostCloseIcon.click();
          } else {
            topMostCloseIcon.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
          }
        }
      }
    };
    document.addEventListener('keydown', handleGlobalKeyDown, true);

    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
      document.removeEventListener('keydown', handleGlobalKeyDown, true);
    };
  }, [])

  const [languageKey, setLanguageKey] = useState(0);

  const { isLoading } = useSkipLoginWithToken();
  const auth = useSelector(getIsAuthorized);
  const hasToChangePin = useSelector(getHasToChangePin);
  const theme = useSelector(getTheme);

  return (
    <MuiThemeProvider theme={createTheme(theme?.theme)}>
      <BrowserRouter>
        <Loader open={isLoading} />
        {
          (auth && !hasToChangePin) ?
            <Wrapper key={`wrapper-${languageKey}`} />
            :
            <OuterRoutes />
        }
      </BrowserRouter>
      <Snackbar />
      <Dialog />
    </MuiThemeProvider>
  );
}

export default App;